export default "__VITE_ASSET__BF1$5R9b__"